import { render, staticRenderFns } from "./assistant-composer.vue?vue&type=template&id=e75090ec&scoped=true"
import script from "./assistant-composer.vue?vue&type=script&lang=js"
export * from "./assistant-composer.vue?vue&type=script&lang=js"
import style0 from "./assistant-composer.vue?vue&type=style&index=0&id=e75090ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75090ec",
  null
  
)

export default component.exports